import { TextValidator, ValidatorComponentProps } from 'react-material-ui-form-validator';

interface ITextValidatorHcs extends ValidatorComponentProps {
    shrink?: boolean
}

export const TextValidatorHcs = (params: ITextValidatorHcs) => {
    return (
        <TextValidator 
            {...params}
            value={params.value || ""}
            InputLabelProps={{ shrink: params.shrink || (!!params.value || params.type === "date" || params.type === "file") }}
        />
    );
}

